<template>
  <div class="channel-wrapper">
    <div
      class="computed-tooltip"
      v-for="(ch, index) in checkboxes"
      :key="index"
    >
      <v-tooltip color="bg" top :disabled="!hoverable">
        <template v-slot:activator="{ on }">
          <h4
            :class="`checkBox ${boxClass[ch.id]} ${disabledClass}`"
            v-on="on"
            v-on:click="onClickHandler(ch)"
            v-on:mouseover="$set(showToolTip, ch.id, true)"
            v-on:mouseleave="$set(showToolTip, ch.id, false)"
          >
            <span>
              {{ `${ch.name}: ` }}
              <span
                :class="ch.value !== 'No Data' ? 'number--text' : 'error--text'"
              >
                {{
                  ch.value !== "No Data"
                    ? parseFloat(ch.value).toFixed(2)
                    : $t(ch.value)
                }}</span
              ></span
            >
          </h4>
        </template>
        <span class="toooltip-text__color">
          <slot
            name="tooltip"
            :value="ch"
            :showToolTip="showToolTip[ch.id]"
          ></slot>
        </span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    id: String,
    selectAll: {
      type: Boolean,
      default: false,
    },
    clearAll: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    condition: Function,
    hoverable: {
      type: Boolean,
      default: false,
    },
    onClick: Function,
  },
  data() {
    return {
      showToolTip: {},
      isActive: {},
      checkboxes: [],
    };
  },
  computed: {
    disabledClass() {
      return this.disable ? "disable" : "";
    },
    boxClass() {
      const classObj = {};
      this.checkboxes.forEach((ch, index) => {
        const classString = this.condition(
          ch,
          this.isActive[`${this.id}-${ch.id}`]
        );
        if (classString.includes("default")) {
          let cl = classString.replace(
            "default",
            this.checkboxes[index].status
          );
          classObj[ch.id] = cl;
        } else {
          classObj[ch.id] = classString;
        }
      });
      return classObj;
    },
  },
  mounted() {
    this.checkboxes = _.cloneDeep(this.data);
  },
  methods: {
    onClickHandler(ch) {
      if (!this.disable) {
        this.onClick(ch, this.isActive, this.id);
      }
    },
  },
  watch: {
    data() {
      this.checkboxes = _.cloneDeep(this.data);
    },
    selectAll: {
      handler() {
        this.checkboxes.forEach((ch) => {
          if (ch.status !== "not_connected") {
            if (this.selectAll) {
              this.$set(this.isActive, `${this.id}-${ch.id}`, true);
            } else {
              this.$set(this.isActive, `${this.id}-${ch.id}`, false);
            }
          }
        });
      },
      deep: true,
    },
    clearAll() {
      this.isActive = {};
      let eleArr = document.querySelectorAll(`.checkBox`);
      eleArr.forEach((el) => {
        el.classList.forEach((e) => {
          if (typeof e === "string" && e.includes("-select")) {
            el.classList.add(e.replace("-select", ""));
            el.classList.remove(e);
          }
        });
      });
    },
  },
};
</script>

<style scoped>
.channel-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
}

.ch-selected {
  border-style: solid;
  border-width: thick;
}

.theme--dark .ch-value_selected {
  border-style: solid;
  border-width: thick;
  animation: datas 1s infinite;
}

.theme--light .ch-value_selected {
  border-style: solid;
  border-width: thick;
  animation: datals 1s infinite;
}

.theme--dark .ch-value {
  animation: data 1s infinite;
}

.theme--light .ch-value {
  animation: datal 1s infinite;
}

.ETSD1001-select {
  background-color: #FF5252;
  border-style: solid;
  border-color: #818fff;
  border-width: thick;
}

.no_issue-select {
  border-style: solid;
  border-color: #818fff;
  border-width: thick;
}

.known_issue-select {
  background-color: #f5be11;
  border-style: solid;
  border-color: #818fff;
  border-width: thick;
}

.not_connected-select {
  background-color: #455a64;
  border-style: solid;
  border-color: #818fff;
  border-width: thick;
}

.communication_error-select {
  background-color: #f69946;
  border-style: solid;
  border-color: #818fff;
  border-width: thick;
}

.str01:ETSD1001-slect {
  background-color: red;
}

.known_issue {
  background-color: #f5be11;
}

.not_connected {
  background-color: #455a64;
}

.communication_error {
  background-color: #f69946;
}

.no_issue {
  background-color: var(--v-primary-darken1);
}

h4 {
  min-width: 128px;
  margin: 4px;
  border-radius: 4px;
  min-height: 35px;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.chisActive h4 {
  min-width: 128px;
  margin: 4px;
  border-radius: 4px;
  min-height: 35px;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.disable {
  opacity: 0.5;
}

@keyframes datas {
  0%,
  49% {
    background-color: var(--v-secondary-base);
  }
  50%,
  100% {
    background-color: var(--v-error-base);
  }
}

@keyframes data {
  0%,
  49% {
    background-color: var(--v-secondary-base);
  }
  50%,
  100% {
    background-color: var(--v-error-base);
  }
}

@keyframes datals {
  0%,
  49% {
    background-color: var(--v-secondary-base);
  }
  50%,
  100% {
    background-color: var(--v-error-base);
  }
}

@keyframes datal {
  0%,
  49% {
    background-color: var(--v-secondary-base);
  }
  50%,
  100% {
    background-color: var(--v-error-base);
  }
}

.theme--light .toooltip-text__color {
  color: #000;
}
</style>
